<template>
  <v-card
    color="grey lighten-4"
    light
  >
    <v-card-text>
      <content-section
        id="timeline"
        :title="detailed ? 'Minha vida todinha' : 'Minhas experiências'"
      >
        <template slot="actions">
          <div>
            <v-switch
              v-model="detailed"
              :label="detailed ? 'Detailed' : 'Summary'"
            />
          </div>
        </template>

        <v-timeline
          dense
        >
          <v-timeline-item
            v-for="(item, i) in orderedItems"
            :key="i"
            :icon="item.icon || ''"
            :class="{transparent: item.transparent}"
            large
          >
            <template
              v-if="item.iconImage"
              v-slot:icon
            >
              <v-avatar>
                <img
                  :src="publicPath(item.iconImage)"
                >
              </v-avatar>
            </template>
            <template v-slot:opposite />
            <v-layout>
              <v-flex
                v-if="$vuetify.breakpoint.smAndUp"
                md1
                sm2
                align-self-center
              >
                <span>{{ item.year }}</span>
              </v-flex>
              <v-flex
                md11
                sm10
                xs12
              >
                <v-card class="elevation-1">
                  <v-card-title class="pb-0">
                    <div>
                      <p v-if="$vuetify.breakpoint.xsOnly">
                        {{ item.year }}
                      </p>
                      <h3>{{ item.title }}</h3>
                    </div>
                  </v-card-title>
                  <v-card-text>
                    <v-layout wrap>
                      <v-flex
                        :md7="!!item.image"
                        :md12="!item.image"
                        xs12
                      >
                        <div class="mr-1">
                          <span
                            v-if="item.text"
                            class="pre"
                          >{{ item.text }}</span>
                          <!-- eslint-disable vue/no-v-html -->
                          <div
                            v-else-if="item.html"
                            v-html="item.html"
                          />
                          <!-- eslint-enable vue/no-v-html -->
                        </div>
                      </v-flex>
                      <v-flex
                        v-if="item.image"
                        md5
                        xs12
                      >
                        <div
                          class="mt-2"
                        >
                          <v-carousel
                            v-if="Array.isArray(item.image)"
                            :show-arrows="false"
                            :height="325"
                          >
                            <v-carousel-item
                              v-for="(citem,ci) in item.image"
                              :key="ci"
                              :src="publicPath(citem)"
                            />
                          </v-carousel>
                          <v-img
                            v-else
                            :max-height="item.imageHeight ? item.imageHeight : ''"
                            :src="publicPath(item.image)"
                          />
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-timeline-item>
        </v-timeline>
      </content-section>
    </v-card-text>
  </v-card>
</template>

<script>
/* eslint no-trailing-spaces: "error" */

import ContentSection from '@/views/dark-template/content/Section'
export default {
  name      : 'Timeline',
  components: { ContentSection },
  data      : () => ({
    detailed: true,
    items   : [
      {
        detailed   : true,
        transparent: true,
        year       : '1992',
        title      : 'Nascido em 18 de Fevereiro de 1992',
        html       : 'Com uma chance de %0.00000000000512.<br> estreiei. ',
        icon       : 'mdi-cake-variant',
      },
      {
        detailed   : true,
        transparent: false,
        year       : '2003',
        title      : 'Primeiro curso de informática',
        html       : 'Iniciei meu primeiro curso de informática na escola Microcamp (Será que esta escola ainda existe?) O curso contava com uma Grade espetacular como: "<br> <ul><li>Windows 98,</li><li>Word</li><li>Excel</li><li>PowerPoint</li><li>Access</li><li>FrontPage</li><li>E INTERNETTT o.O</li></ul>',
        icon       : 'mdi-mouse-variant',
      },
      {
        detailed   : true,
        transparent: false,
        year       : '2004',
        title      : 'Segundo curso de informática - Hardware',
        html       : 'Será que hoje em dia ainda existe curso de Hardware? Pois é, em 2004 e existia e eu fiz, adivinha onde? Sim... na microcamp. Se liga nesta foto com alguns colegas do curso. Bons tempos.',
        image      : 'img/timeline/hardware.JPG',
        imageHeight: 200,
        icon       : 'mdi-tools',
      },
      {
        detailed   : false,
        transparent: false,
        year       : '2004 - 2007',
        title      : 'Professor Voluntário na Casa Unimed de Ações Sociais',
        html       : '<p>Pois é, ao mesmo tempo em que estava adquirindo conhecimento, também queria passar.</p> <p>E assim comecei a dar aulas de Informática Básica na <a target="_blank" href="http://casaunimedtatui.org.br/">Casa Unimed de Ações Sociais</a>, um projeto social Vinculado à Unimed Tatuí.</p><br> Ministrei aulas de Informática Básica por 3 Anos, e de Hardware básico por 6 meses. <br><br> Baita Aprendizado.',
        image      : 'img/timeline/casaunimed.png',
        imageHeight: 300,
        icon       : 'mdi-tools',
      },
      {
        detailed   : false,
        transparent: false,
        year       : '2008',
        title      : 'Primeiro Trabalho CLT - Professor de Robótica',
        html       : '<p>Este costumo dizer que é o trabalho do sonhos pra quem gosta de Lego hehe.</p> '
                     + '<p>Meu trabalho era ministrar aulas de robótica utilizando Kits da Lego. Ou seja, montavamos lego, programavamos o robozinho e ficavamos brincando com as crianças. </p>'
                     + '<p>Dentre as habilidades estimuladas nas aulas, eram criatividade, trabalho em grupo e dinamismo, e confesso... realmente funcionava</p>'
                     + 'No final de 2008 organizamos um Campeonato de Robótica interno na escola e todos que participaram ganharam uma viagem para o Hopi Hari.'
                     + '<br> <br> Pura Diversão',
        image      : 'img/timeline/robotica.jpg',
        imageHeight: 300,
        icon       : 'mdi-tools',
      },
      {
        detailed   : true,
        transparent: true,
        year       : '2009',
        title      : 'Mudança para São Paulo',
        html       : '<p>Em Fevereiro de 2009 recebi a noticia que havia ganhado uma Bolsa Integral para Engenharia da Computação na Universidade Metodista de São Paulo, com isso, eu e minha família viemos para São Paulo e nos Fixamos em Mauá ',
        icon       : 'mdi-city',
      },
      {
        detailed   : false,
        transparent: false,
        year       : '2009',
        title      : 'Analista Programador Delphi - 2M Solutions',
        html       : '<p>A <a target="_blank" href="http://www.2msolutions.com.br/"> 2M Solutions </a> é uma empresa focada no desenvolvimento de sistemas e aplicações para a área de Radiologia. </p>'
                     + '<p>Meu papel era cuidar da manutenção, suporte e novas implementações em um sistema de Captura e gravação de Imagens de Ultrasonografia. </p>'
                     + '<p>Este trabalho me proporcionou diversos desafios, mais o maior com certeza foi ter que aprender a trabalhar com Imagens em tempo de programação, visto que precisei implementar algumas rotinas para seleção de imagens, inversão de cores, recorte e afins. </p>'
                     + '<p> Alguma das competências, ferramentas e habilidades adquiridas nesta experiência foram</p>'
                     + '<ul>'
                     + '<li> Borland Delphi 7 </li>'
                     + '<li> Firebird </li>'
                     + '<li> Tratamento de Imagens </li>'
                     + '<li> Relacionamento com Clientes </li>'
                     + '</ul>'
                     + '<br><p>Nesta passagem, fiquei apenas por 11 meses na 2M, porém no futuro, voltei pra lá acompanhem as cenas dos próximos capítulos...</p>',
        iconImage: 'img/timeline/2m.png',
      },
      {
        detailed   : false,
        transparent: false,
        year       : '2009',
        title      : 'Estágio como Analista de Suporte - T-Systems do Brasil',
        html       : '<p>A <a target="_blank" href="http://www.t-systems.com.br/"> T-Systems</a> é uma empresa empresa Alemã pertencente ao grupo Doutsche Telekom focada no fornecimento de Outsourcing de TI e Comunicação.  </p>'
                     + '<p>A minha área trabalhava para Volkswagen, e nosso trabalho era suportar toda a Rede de Concessionárias da Volkswagen e Audi do Brasil em todos os processos de Comunicação com a Fábrica. Algumas das nossas atribuições era direcionar os concessionários para documentos internos da VW, ajuda na transmissão de arquivos digitais para a fábrica, apoio na transmissão de programação da TV VW, entre outras </p>'
                     + '<p> Alguma das competências, ferramentas e habilidades adquiridas nesta experiência foram</p>'
                     + '<ul>'
                     + '<li> Conceito de EDI </li>'
                     + '<li> Atendimento a Cliente </li>'
                     + '<li> Ambiente Mainframe </li>'
                     + '<li> Sistemas Internos Volkswagen</li>'
                     + '</ul>'
                     + '<br><p>Nesta passagem, fiquei apenas por 9 meses na 2M, porém no futuro, voltei pra lá acompanhem as cenas dos próximos capítulos...</p>',
        iconImage: 'img/timeline/tsystems.png',

      },
      {
        detailed   : false,
        transparent: false,
        year       : '2009',
        title      : 'Analista Programador Delphi - Grupo Marfrig',
        html       : '<p>A <a target="_blank" href="http://www.marfrig.com.br/"> Grupo Marfrig </a> É uma das maiores companhias de alimentos à base de proteína animal do Mundo. </p>'
                     + '<p>Eu fazia parte de um time de 4 analistas, onde nosso Papel era o desenvolvimento do "Sistema Marfrig", um sistema Auxiliar ao ERP Logix, que era utilizado pela companhia. </p>'
                     + '<p>Na época, o Grupo utilizava o sistema Logix como ERP, porém era uma versão antiga, e tinha diversos GAPs. O Objetivo da minha equipe era preencher estes Gaps através de um sistema auxiliar que compartilhasse a base de dados do logix, porém podia ser mantido 100% internamente.'
                     + '<p>Alguns dos principais processos que era realizado através do Sistema Marfrig era o processo de Pedido, Contas a Pagar, Contas a Receber e diversos relatórios. </p>'
                     + '<p> Alguma das competências, ferramentas e habilidades adquiridas nesta experiência foram</p>'
                     + '<ul>'
                     + '<li> Borland Delphi 7 </li>'
                     + '<li> Informix </li>'
                     + '<li> Logix </li>'
                     + '<li> SVC Tortoise </li>'
                     + '<li> PL SQL Avançado </li>'
                     + '<li> Relacionamento entre áreas </li>'
                     + '<li> Análise de Documentações </li> '
                     + '<li> Especificação de Requisitos </li> '
                     + '<li> Integração entre Sistemas </li> '
                     + '</ul>'
                     + '<br><p>Em 2012 deixei a Marfrig para ir morar em Portugal</p>',
        iconImage: 'img/timeline/marfrig.jpg',
      },
      {
        detailed   : true,
        transparent: true,
        year       : '2012',
        title      : 'Intercâmbio para Lisboa',
        html       : '<p> Em meados de 2012, fui aprovado pelo Programa Ciências sem Fronteira para uma Bolsa de Estudos de 10 meses em Lisboa, Portugal. </p>'
                     + '<p> Como parte do intercâmbio, cursei matérias do curso de Mestrado em Ciências da Comunicação, internet e Novas Mídias na Universidade Católica Portuguesa. </p>',
        image    : 'img/timeline/portugal.jpg',
        iconImage: 'img/timeline/portugal2.png',

      },
      {
        detailed   : true,
        transparent: true,
        year       : '2012',
        title      : 'Primeiro Mochilão',
        html       : '<p> Ainda em 2012, junto a alguns amigos, realizei meu primeiro Mochilão pela Europa, mais especificamente no Norte da Itália. </p>'
                     + '<p> Os destinos foram "Bologna, Veneza, Pisa e Milão"</p>'
                     + '<p> Durante esta viagem, realizei algumas coisas que jamais havia pensado em realizar na Vida, como conhecer a Fábrica da Lamborguini, Voar de Helicoptero sobre Veneza, Andar de Gondola em Veneza e ser expulso de um restaurante em Milão </p>',
        image: 'img/timeline/primeiro.png',
        icon : 'mdi-airplane-takeoff',
      },
      {
        detailed   : true,
        transparent: true,
        year       : '2012-2013',
        title      : 'Segundo Mochilão',
        html       : '<p> Desta vez, também junto a alguns amigos, saimos em mochilão para passar o Natal e o Ano Novo viajando. Resolvemos passar o Natal em Paris e o Ano novo em Berlin, com um Pulinho em Praga. </p>'
                     + '<p> Como mochileiro tem que se !#$%& chegamos em Paris no dia 24 a noite, e não encontramos NADA aberto para comprar para o Natal, e nossa Ceia foi um Crepe de rua um pouco nojento. </p>'
                     + '<p> Além de passar fome no Natal, neste mochilão dormimos em um Aeroporto em Paris, ficamos horas no chão de uma estação de Trem em Berlin, e fomos zoados pelo Fiscal de um Trem.</p>',
        image: 'img/timeline/segundo.png',
        icon : 'mdi-airplane-takeoff',
      },
      {
        detailed   : true,
        transparent: true,
        year       : '2013',
        title      : 'Terceiro Mochilão',
        html       : '<p> Desta vez, fui sozinho. rodando por 20 dias e os destinos foram "Paris, Bruxelas, Amsterdã, Londres e Barcelona" </p>'
                     + '<p> Pra variar, muitos perrengues, mais o principal foi o vencimento do Meu cartão Bancário no segundo dia de viagem, o que fez com que eu tivesse que realizar os 20 dias de viagem com apenas 400 Euros. </p>'
                     + '<p> Fiquei Doente, Comi mais de 1 kg de amendoin durante os dias, Andei Kilometros e Kilometros, mais deu tudo certo o/ </p>',
        image: 'img/timeline/terceiro.png',
        icon : 'mdi-airplane-takeoff',
      },
      {
        detailed   : true,
        transparent: true,
        year       : '2013',
        title      : 'Acampamento no Deserto do Saara',
        html       : '<p> Saimos de Lisboa de ônibus em uma excursão para o Marrocos, que incluía Marrakesh e um Acampamento no meio do Deserto. </p>'
                     + '<p> Esta foi uma viagem incrível, a minha primeira em um Pais de cultura árabe, com alguns perregues mais extremamente divertida. </p>'
                     + '<p> Andei de Camelos, fomos a alguns Bares Proibidos, e me diverti e assustei no famoso Mercado de Marrakesh</p>',
        icon: 'mdi-airplane-takeoff',
      },
      {
        detailed   : true,
        transparent: true,
        year       : '2013',
        title      : 'Último mochilão antes do Retorno ao Brasil',
        html       : '<p> Mais uma vez sozinho, comprei um passe denominado Eurail Pass, que dá direito a turistas extrangeiros, a viajar de trem por toda Europa, com uma tarifa gratuíta na maioria dos trajetos.  </p>'
                     + '<p> Esta foi uma viagem incrível, a minha primeira em um Pais de cultura árabe, com alguns perregues mais extremamente divertida. </p>'
                     + '<p> Andei de Camelos, fomos a alguns Bares Proibidos, e me diverti e assustei no famoso Mercado de Marrakesh</p>',
        image: 'img/timeline/ultimo.png',
        icon : 'mdi-airplane-takeoff',
      },
      {
        detailed   : true,
        transparent: true,
        year       : '2013',
        title      : 'De volta ao Brasil',
        html       : '<p> Finalizado o Intercâmbio, de Volta ao Brasil  </p>',
        icon       : 'mdi-airplane-landing',
      },
      {
        detailed   : false,
        transparent: true,
        year       : '2013-2019',
        title      : 'Analista de Negócios - 2M Solutions',
        html       : '<p> De volta ao Brasil, era preciso trabalhar e recebi a oportunidade de Voltar para a <a target="_blank" href="www.2msolutions.com.br">2M Solutions</a>, porém desta vez com novos desafios. </p>'
                     + '<p> Iniciei na atuação junto aos clientes identificando potenciais melhorias e levando para análise interna, trabalhei com a elaboração de propostas comerciais e acompanhamento comercial de leads e prospects. '
                     + 'Participei de diversas feiras e eventos afim de divulgar e apresentar o portfólio de produtos da 2M, desenvolvimento de sistema, manutenção em infraestrutura cloud, ou seja realmente era um análista de qualquer negócio hehe </p>'
                     + '<p> Estes 7 anos que passei na 2M, tive diversos desafios incríveis, com muito aprendizado, Além de atuar em áreas que nunca tinha imaginado como comercial, participei de todo o processo regulatório da empresa junto a anvisa, escrevendo todo o sistema de qualidade da empresa e assinando como responsável técnico '
                     + ' <br>Em questões técnicas, fui desafiado a cuidar do sistema <a target="_blank" href="www.onrad.com.br"> ONRAD </a> um Sistema online para teleradiologia, sendo responsável pela infraestrutura que era na AWS, melhorias e correções de Bugs (PHP e MySQL), suporte aos principais clientes, gestão do roadmap de desenvolvimento, etc. Também fui responsável pela reestruturação de todo o sistema de Atendimento da empresa, implantando novos métodos e ferramentas. </p>'
                     + '<p> Algumas das competências, ferramentas e habilidades adquiridas nesta experiência foram</p>'
                     + '<div style="float: left; width: 34%;">'
                     + '<ul>'
                     + '<li> Borland Delphi XE4 </li>'
                     + '<li> MYSQL </li>'
                     + '<li> SqlServer </li>'
                     + '<li> GIT </li>'
                     + '<li> BitBucket </li>'
                     + '</ul>'
                     + '</div>'
                     + '<div style="float: left; width: 33%;">'
                     + '<ul>'
                     + '<li> PHP </li>'
                     + '<li> Ferramentas do AWS </li> '
                     + '<li> Gestão de Backlog </li> '
                     + '<li> Atendimento a clientes </li> '
                     + '<li> Ecosistema Freshdesk</li>'
                     + '</ul>'
                     + '</div>'
                     + '<div style="float: left; width: 33%;">'
                     + '<ul>'
                     + '<li> Atividades Regulatórias </li>'
                     + '<li> Gestão da Qualidade </li>'
                     + '<li> Desenvolvimento Ágil </li>'
                     + '<li> Trello </li>'
                     + '</ul>'
                     + '</div>',
        iconImage: 'img/timeline/2m.png',
      },
      {
        detailed   : true,
        transparent: true,
        year       : '2014',
        title      : 'Formatura em Engenharia da Computação',
        html       : '<p> Finalmente o grande dia chegou, formatura da primeira graduação em Engenharia da Computação  </p>',
        image      : 'img/timeline/formatura.jpg',
        imageHeight: 300,
        icon       : 'mdi-school',
      },
      {
        detailed   : true,
        transparent: true,
        year       : '2016',
        title      : 'Casamento com a Patricia',
        html       : '<p> Nos conhecemos em 2012, pelo Facebook. Ela era amiga de uma Prima e morava em Minas e eu estava morando em portugal. Começamos a nos falar, falar, falar, voltei para o Brasil. Assim que cheguei, fui até minas para conhece-la. Após uma viagem de 12 horas de ônibus, cansado sem dormir, me encantei por aquele sorriso. </p>'+ 
                     '3 anos de namoro a distância se passaram, e resolvemos oficializar nosso relacionamento e nos casamos, em uma Cerimonia muito quente, com muita emoção como sempre, e que rendeu boas histórias com nossos amigos.',
        image      : 'img/timeline/casamento.jpg',
        imageHeight: 300,
        icon       : 'mdi-account-multiple',
      },
      {
        detailed   : false,
        transparent: false,
        year       : '2019',
        title      : 'Consultor de Implantação - e-Core',
        html       : '<p> A <a target="_blank" href="www.e-core.com"/>e-Core</a> é uma das principais parceiras Atlassian do Brasil, e atua em diversos segmentos como Consultoria, desenvolvimento de Softwares e suporte </p>' + 
                     '<p> Iniciei na e-Core com o desafio de trabalhar como Consultor de produtos Atlassian, os quais conhecia apenas o BitBucket e Trello, como usuário. Porém os primeiros meses foram de treinamentos intensos, e um processo de Onboard extremamente completo que me fez aprender muito sobre o universo atlassian e cultura e valores da empresa. </p>' +
                     '<p> Após quase 2 meses de Treinamento, iniciei em meu primeiro projeto com um baita desafio, se tratava de um projeto de Migração de Zendesk para Jira Service Desk integrando com Jira Software, o projeto demandou grande visibilidade de dados, e eu fiquei responsável pela criação e apresentação de Dashboards para níveis operacionais e gerenciais. </p>' + 
                     '<p> Meu segundo projeto foi ainda mais desafiador, eu e mais 4 consultores entramos com a missão de Migrar um sistema de mais de 80 milhões de linhas de código de TFS para ecosistema Atlassian, além disso, fomos responsáveis pelo treinamento em Git, JIRA e Bitbucket de uma equipe de mais de 100 profissionais. O próximo desafio já foi solitário, e foi o apoio deste mesmo time na redução do tempo de build do sistema, onde consegui entregar um resultado de redução de 90% no tempo. </p>' +
                     '<p> Atualmente sigo aqui na e-Core, e a cada dia novos desafios surgem nos mais diversos clientes e segmentos. ' 
                   + '<p> Algumas das competências, ferramentas e habilidades adquiridas nesta experiência foram</p>'
                   + '<div style="float: left; width: 34%;">'
                   + '<ul>'
                   + '<li> JIRA Software </li>'
                   + '<li> JIRA Service Desk </li>'
                   + '<li> Trello </li>'
                   + '<li> GIT </li>'
                   + '<li> BitBucket </li>'
                   + '<li> Confluence </li>'
                   + '<li> Bamboo </li>'
                   + '</ul>'
                   + '</div>'
                   + '<div style="float: left; width: 33%;">'
                   + '<ul>'
                   + '<li> Groovy Scripts </li>'
                   + '<li> VueJS </li> '
                   + '<li> Python </li> '                   
                   + '<li> TFS </li> '
                   + '<li> Cultura DevOPS </li> '
                   + '<li> Metodologias Ágeis </li> '
                   + '<li> SAFe </li> '
                   + '</ul>'
                   + '</div>'
                   + '<div style="float: left; width: 33%;">'
                   + '<ul>'
                   + '<li> ScriptRunner </li>'
                   + '<li> Automation for JIRA </li>'
                   + '<li> EazyBI</li>'         
                   + '<li> TimeToSLA</li>'          
                   + '<li> Portfólio</li>'           
                   + '<li> BigPicture</li>'                   
                   + '</ul>'
                   + '</div>',
        image      : 'img/timeline/e-core.png',
        imageHeight: 300,
        iconImage  : 'img/timeline/ecorito.png',
      },
      {
        detailed   : true,
        transparent: true,
        year       : '2019',
        title      : 'Formatura em Informática para Negócios',
        html       : '<p> Depois de mais longos 3 anos, me formei em minha segunda graduação na FATEC de Mauá, a qual ingressei para aprofundar um pouco mais meu conhecimento na área de Negócios.  </p>',
        imageHeight: 300,
        icon       : 'mdi-school',
      },      
      {
        year : '2020',
        title: 'Desenvolvimento do Revelachá',
        html : `
          <p>
              Current status: <span class="light-blue--text lighten-3">Published</span><br>
              Available on: <a target="_blank" href="https://www.revelacha.com.br">www.revelacha.com.br</a>

          </p>
          <p>
            <a target="_blank" href="https://www.revelacha.com.br">Revelacha</a> é uma plataforma desenvolvida durante a Pandemia do Corona Virus, para satisfazer uma necessidade Pessoal. Minha esposa descobriu que estava grávida, e queria compartilhar o momento da revelação do Sexo do Bebê junto aos nossos amigos e familiares.
          </p>
          <p>
            Para isso, desenvolvi uma plataforma onde é possível cadastrar as informações do Chá Revelação, após o cadastro, o usuário recebe um link único para o seu Chá, que terá uma contagem regressiva até a data e hora definida para a revelação. No horário da revelação, o site poderá revelar automaticamente, mudando a cor conforme o sexo do Bebê, ou iniciar uma chamada de vídeo para transmitir um evento de revelação. Além disso é possível criar lista de presentes para compartilhar com os convidados, receber mensagens dos convidados, além de disponbilizar uma enquete para que as pessoas palpitem se o bebê é menino ou menina.
          </p>
        `,
        image    : 'img/timeline/revelachalg.png',
        iconImage: 'img/timeline/revelacha.png',
      },
      {
        year : '2020',
        title: 'Quoon',
        html : `
          <p>
              Current status: <span class="light-green--text lighten-3">Em Desenvolvimento</span><br>
              Available on: <a target="_blank" href="https://www.quoon.com.br">www.quoon.com.br</a>
          </p>
          <p>
            Uma plataforma para realização de Pedidos via Whatsapp, com disponibilização de um Portal para que o Comerciante possa gerir os seus produtos, categorias e catálogo, personalizar o layout do seu catálogo e acompanhar os seus Pedidos.  
          </p>
        `,
        image: 'img/timeline/quoonlg.png',
        iconImage: 'img/timeline/quoon.png',
      },
    ],
  }),
  computed: {
    orderedItems () {
      const items = [...this.items].reverse()
      if (this.detailed)
        return items
      return items.filter((item) => {
        return !item.detailed
      })
    },
  },
}
</script>

<style scoped>
.title {
  border-bottom: 2px #bfbfbf solid;
  line-height: 1.5 !important;
}
.pre {
  white-space: pre;
}
.transparent{
  opacity: 0.6;
}
</style>
